import {CardContent, FormHelperText, Grid} from "@mui/material";
import {Checkbox, EditForm, TextField} from "@variocube/app-ui";
import React, {useEffect, useState} from "react";
import {LegalSettings} from "../../api";
import {useLocalization} from "@smalox/shared";

interface LegalSettingsEditFormProps {
	loading: boolean;
	legalSettings?: LegalSettings;
	onSave: (legalSettings: LegalSettings) => Promise<any>;
}

export function LegalSettingsEditForm(props: LegalSettingsEditFormProps) {
	const {t} = useLocalization();
	const {loading, legalSettings, onSave} = props;

	const [requireTermsAcceptance, setRequireTermsAcceptance] = useState(false);
	const [requirePrivacyAcceptance, setRequirePrivacyAcceptance] = useState(false);
	const [termsAndConditionsUrl, setTermsAndConditionsUrl] = useState("");
	const [privacyPolicyUrl, setPrivacyPolicyUrl] = useState("");
	const [sendAcceptedDocumentsByEmail, setSendAcceptedDocumentsByEmail] = useState(false);

	useEffect(() => {
		if (legalSettings) {
			setRequireTermsAcceptance(legalSettings.requireTermsAcceptance ?? false);
			setRequirePrivacyAcceptance(legalSettings.requirePrivacyAcceptance ?? false);
			setTermsAndConditionsUrl(legalSettings.termsAndConditionsUrl ?? "");
			setPrivacyPolicyUrl(legalSettings.privacyPolicyUrl ?? "");
			setSendAcceptedDocumentsByEmail(legalSettings.sendAcceptedDocumentsByEmail ?? false);
		}
	}, [legalSettings]);

	async function handleSave() {
		await onSave({
			requireTermsAcceptance,
			requirePrivacyAcceptance,
			termsAndConditionsUrl: termsAndConditionsUrl || undefined,
			privacyPolicyUrl: privacyPolicyUrl || undefined,
			sendAcceptedDocumentsByEmail,
		});
	}

	return (
		<EditForm loading={loading} labels={t} onSave={handleSave}>
			<CardContent>
				<Grid container spacing={3}>
					<Grid item xs={12}>
						<Checkbox
							label={t("settings.legal.requireTermsAcceptance.title")}
							checked={requireTermsAcceptance}
							onChange={setRequireTermsAcceptance}
						/>
						<FormHelperText>{t("settings.legal.requireTermsAcceptance.helperText")}</FormHelperText>
					</Grid>
					<Grid item xs={12}>
						<TextField
							label={t("settings.legal.termsAndConditionsUrl.title")}
							value={termsAndConditionsUrl}
							onChange={setTermsAndConditionsUrl}
							disabled={!requireTermsAcceptance}
							fullWidth
						/>
						<FormHelperText>{t("settings.legal.termsAndConditionsUrl.helperText")}</FormHelperText>
					</Grid>
					<Grid item xs={12}>
						<Checkbox
							label={t("settings.legal.requirePrivacyAcceptance.title")}
							checked={requirePrivacyAcceptance}
							onChange={setRequirePrivacyAcceptance}
						/>
						<FormHelperText>{t("settings.legal.requirePrivacyAcceptance.helperText")}</FormHelperText>
					</Grid>
					<Grid item xs={12}>
						<TextField
							label={t("settings.legal.privacyPolicyUrl.title")}
							value={privacyPolicyUrl}
							onChange={setPrivacyPolicyUrl}
							disabled={!requirePrivacyAcceptance}
							fullWidth
						/>
						<FormHelperText>{t("settings.legal.privacyPolicyUrl.helperText")}</FormHelperText>
					</Grid>
					<Grid item xs={12}>
						<Checkbox
							label={t("settings.legal.sendAcceptedDocumentsByEmail.title")}
							checked={sendAcceptedDocumentsByEmail}
							onChange={setSendAcceptedDocumentsByEmail}
							disabled={!requireTermsAcceptance && !requirePrivacyAcceptance}
						/>
						<FormHelperText>{t("settings.legal.sendAcceptedDocumentsByEmail.helperText")}</FormHelperText>
					</Grid>
				</Grid>
			</CardContent>
		</EditForm>
	);
}
